import { Injectable, Injector } from '@angular/core';

import { HttpInterceptor } from '@angular/common/http';
import { CucurachaAdminService } from './cucuracha.service';
@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
    constructor(private Injector:Injector) {

    }
    intercept(req, next) {
        let authService=this.Injector.get(CucurachaAdminService)
        let tokenizedReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${authService.getToken()}`
            }
        })
        return next.handle(tokenizedReq)
    }
}